import React from "react";
import gridOne from "../../images/hackathon/hackathon-grid-1.png"; 
import gridTwo from "../../images/hackathon/encode-denver.jpeg"; 
import gridThree from "../../images/hackathon/hackathon-grid-3.png"; 
import gridFour from "../../images/hackathon/hackathon-grid-4.png"; 
import gridFive from "../../images/hackathon/hackathon-grid-5.png"; 
import gridSix from "../../images/hackathon/hackathon-grid-6.png"; 
import gridSeven from "../../images/hackathon/hackathon-grid-7.png"; 
import gridEight from "../../images/hackathon/hackathon-grid-8.png"; 
import danielImage from "../../images/hackathon/daniel-sf.png"; 


const cards = [
  { id: 1, type: "image", title: "ETH Global San Francisco 2024", imgSrc: gridOne, height: 555 },
  { id: 2, type: "image", title: "ETH Global Bangkok 2024", imgSrc: gridSeven, height: 263 },
  { id: 3, type: "stat", value: "$300,000+", description: "Prizes Distributed", color: "yellow", height: 263 },
  { id: 4, type: "image", title: "Bitcoin Games 2024 Nashville", imgSrc: gridThree, height: 555 },
  { id: 5, type: "stat", value: "600+", description: "Hackathon|participants", color: "green", height: 263 },
  { id: 6, type: "image", title: "ETH Global Brussels 2024", imgSrc: gridFour, height: 263 },
  { id: 7, type: "image", title: "Encode Club Bitcoin Hackathon Bangkok", imgSrc: gridFive, height: 263 },
  { id: 8, type: "image", title: "ETH Global Brussels 2024", imgSrc: danielImage, height: 555 },
  { id: 9, type: "stat", value: "150+", description: "Projects built|on Rootstock", color: "orange", height: 263 },
  { id: 10, type: "stat", value: "20+", description: "Hackathons|sponsored", color: "purple", height: 263 },
  { id: 11, type: "image", title: "ETH Global Brussels 2024", imgSrc: gridSix, height: 263 },
  { id: 12, type: "image", title: "Encode Denver 2025", imgSrc: gridTwo, height: 263 },
  { id: 13, type: "image", title: "ETH Global Bangkok 2024", imgSrc: gridEight, height: 263 },
];

const Card = ({ card }) => {
  const baseStyle = {
    width: "400px",
    margin: "0.5rem",
    overflow: "hidden",
    position: "relative",
  };

  const gridStyle = card.height === 555 ? { gridRow: "span 2" } : {};
  const combinedStyle = { ...baseStyle, ...gridStyle };

  if (card.type === "stat") {
    const bgColor = card.color || "cyan";
    const descriptionLines = Array.isArray(card.description)
      ? card.description
      : card.description.split("|");

    return (
      <div className="card bg-black text-white" style={{ ...combinedStyle, height: "263px" }}>
        <div className="card-body p-0 d-flex flex-column justify-content-start align-items-start">
          <h3 className="h4 text-black mb-5 d-flex align-items-start">
            <span className="d-flex flex-column align-items-start me-2">
              {descriptionLines.map((line, index) => (
                <span key={index} className={`bg-${bgColor} zg-line-height-sm letter-spacing-1 p-2 mb-1`}>
                  {line}
                </span>
              ))}
            </span>
          </h3>
          <span className="text-white h3">{card.value}</span>
        </div>
      </div>
    );
  } else if (card.type === "image") {
    return (
      <figure className="card rounded" style={{ ...combinedStyle, height: `${card.height}px` }}>
        <img src={card.imgSrc} alt={card.title} className="card-img" style={{ objectFit: "cover", width: "100%", height: "100%" }} />
        <figcaption className="card-img-overlay d-flex flex-column justify-content-center p-2 overlay-caption">
          <h5 className="card-title text-white">{card.title}</h5>
        </figcaption>
      </figure>
    );
  }
  return null;
};

const MarqueeComponent = () => {
  return (
    <section>
    <div className="container">
      <div className="testimonial-header">
          <span className="zg-label bg-pink mb-5">Innovate</span>
          <h2 className="h3 mt-3">Meet The Hackers Shaping Bitcoin’s Future</h2>
      </div>
    </div>
    <div className="marquee-container">
      <div className="marquee-track">
        <div className="marquee-grid">
          {cards.map((card, index) => (
            <Card key={`card-${index}`} card={card} />
          ))}
        </div>
        <div className="marquee-grid">
          {cards.map((card, index) => (
            <Card key={`dup-${index}`} card={card} />
          ))}
        </div>
      </div>
    </div>
  </section>
  );
};

export default MarqueeComponent;
